<template>
  <div>
    <uni-popup ref="searchCheck" type="bottom">
      <uni-card title="项目" :is-full="true">
        <div class="search">
          <uni-search-bar
            v-model="searchValue"
            bg-color="#fff"
            placeholder="请输入项目名称"
            @confirm="search"
            @cancel="cancelAddCheck"
          />
          <div class="drug_wrap">
            <div
              v-for="(item, i) in treatmentItemsList"
              :key="i"
              class="drug_msg"
              @click="setDrugMsg(item)"
            >
              <div class="add_row">
                <span class="drug_name">{{ item.itemName }}</span>
                <img class="add_img" src="@funcPuzzle/mini_doctor/add.png" />
              </div>
              <div class="row_wrap">
                <span class="price">¥ {{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-check-msg
      ref="checkMsg"
      v-model="showCheckMsg"
      :drug-msg="checkMsg"
      v-model:visible="showCheckMsg"
      :checkType="checkType"
    />
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { getTreatmentItemsList } from '@/views/funcPuzzle/utils/index.js'
import MsCheckMsg from '@/views/funcPuzzle/components/ms-check-msg/ms-check-msg.vue'

export default {
  components: {
    MsCheckMsg
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    checkType: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      searchValue: '',
      treatmentItemsList: [],
      showCheckMsg: false,
      checkMsg: ''
    }
  },
  methods: {
    getKeyValueText,
    close() {
      if (!this.$refs.searchCheck) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.searchCheck.close()
    },
    open() {
      this.$refs.searchCheck.open()
      this.getSymptomListByCache()
    },
    search(val) {
      this.getSymptomListByCache()
    },
    getSymptomListByCache() {
      getTreatmentItemsList({
        pageNum: '1',
        pageSize: 100,
        keyword: this.searchValue || '',
        itemType: this.checkType,
        state: '1'
      }).then(rs => {
        this.treatmentItemsList = rs.TreatmentItemsList
      })
    },
    setDrugMsg(item) {
      item.drugFlag = new Date().getTime()
      this.checkMsg = item
      this.$refs.searchCheck.close()
      this.searchValue = ''
      this.treatmentItemsList = []
      this.$emit('input', false)
      this.showCheckMsg = true
      this.$refs.checkMsg.open()
    },
    cancelAddCheck() {
      this.$refs.searchCheck.close()
      this.$bus.emit('cancelAddCheck', true)
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.searchCheck.open()
      } else {
        this.searchValue = ''
        this.treatmentItemsList = []
        this.close()
      }
    },
    checkType(val) {}
  },
  unmounted() {
    this.$bus.off('cancelAddCheck')
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.drug_wrap {
  height: 19.2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .drug_msg {
    display: flex;
    flex-direction: column;
    height: 2.133333rem;
    padding: 0.682667rem 0;
    border-bottom: 0.021333rem solid #ececec;
    justify-content: space-between;
    margin-left: 0.682667rem;
    width: 14.634667rem;
    .add_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .add_img {
        width: 0.853333rem;
        height: 0.853333rem;
      }
    }

    // text:first-child,
    // text:nth-child(2) {
    //   // margin-bottom: .256rem;
    // }
    .drug_name {
      font-size: 0.64rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
      max-width: 12.373333rem;
    }

    .price {
      font-size: 0.64rem;

      font-weight: 400;
      color: #f86767;
      line-height: 0.704rem;
    }
    .row_wrap {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
